<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import communityApi from '@/apis/community';
import InteractionDetailPanel from '@/app/community/components/InteractionDetailPanel.vue';
import { useInteractionDetail } from '@/app/community/composables/useInteractionDetail';
import { useCommunityInteractionStore } from '@/stores/community-interactions';
import { useCommunityMultiBrandsStore } from '@/stores/community-multi-brands';

const route = useRoute();
const interactionStore = useCommunityInteractionStore();
const multiBrandStore = useCommunityMultiBrandsStore();

const { interactionDetail, getInteractionDetail } = useInteractionDetail();

const loading = ref(false);

onMounted(async () => {
  loading.value = true;
  try {
    const { caseId } = route.params;
    const response = await communityApi.getCaseById({ ticketSourceId: caseId });
    const { id, type, brandId } = response?.data?.data ?? {};

    const interaction = await interactionStore.getCommunityInteraction({
      brandIds: String(brandId),
      id,
      type,
    });
    interactionStore.communityInteractions = [interaction];
    interactionStore.setSelectedCommunityInteraction(interaction);

    await getInteractionDetail();

    await multiBrandStore.setupMultiBrandFilters();
  } finally {
    loading.value = false;
  }
});

async function onRefresh() {
  loading.value = true;
  try {
    await getInteractionDetail();
  } finally {
    loading.value = false;
  }
}
onUnmounted(() => {
  interactionStore.clearCommunityInteractions();
});
</script>

<template>
  <div class="dash-h-full">
    <InteractionDetailPanel
      :loading="loading"
      :detail-data="interactionDetail"
      is-embed
      @refresh="onRefresh"
    />
  </div>
</template>
